module.exports = __webpack_public_path__ + "assets/img/Location.32bb021f.png";